import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ReactExport from 'react-data-export';
import dayjs from 'dayjs';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const useStyles = makeStyles(() => ({
    download: {
        backgroundColor: '#6E6E6E',
        borderColor: '#6E6E6E',
        '&:hover': {
            backgroundColor: '#6E6E6E',
            borderColor: '#6E6E6E',
            boxShadow: 'none'
        }
    },
    search: {
        backgroundColor: '#0d6efd',
        borderColor: '#0d6efd',
        '&:hover': {
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd',
            boxShadow: 'none'
        }
    }
}));

const defButtonsNames = ['Search to download', 'Download excel'];

const DownloadExcel = ({ margin, fileName, sheetName, buttonsNames = defButtonsNames, data, columns, onClick, onReset }) => {
    const classes = useStyles();

    return (
        <div>
            {
                data?.length ?
                    <ExcelFile
                        filename={`${dayjs().format('YYYY-MM-DD')}-${fileName}`}
                        element={<Button variant='contained' className={classes.download} onClick={onReset} style={{ marginRight: margin ? 15 : 0 }}>{buttonsNames[1]}</Button>}
                    >
                        <ExcelSheet data={data} name={sheetName}>
                            {
                                columns?.map((item, i) => <ExcelColumn key={`${i}`} label={item.label} value={item.value} />)
                            }
                        </ExcelSheet>
                    </ExcelFile>
                    :
                    <Button variant='contained' className={classes.search} onClick={onClick} style={{ marginRight: margin ? 15 : 0 }}>{buttonsNames[0]}</Button>
            }
        </div>
    )
}

export default DownloadExcel;